import { render, staticRenderFns } from "./zhHantUser.vue?vue&type=template&id=023941e8&scoped=true&"
import script from "./zhHantUser.vue?vue&type=script&lang=js&"
export * from "./zhHantUser.vue?vue&type=script&lang=js&"
import style0 from "./zhHantUser.vue?vue&type=style&index=0&id=023941e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023941e8",
  null
  
)

export default component.exports